module.exports = __webpack_public_path__ + "img/product-home.a1454487.jpg";